import request from '@/utils/request'

const url = '/auth-service/users'

export function page(params) {
  return request({
    url: `${url}/page`,
    method: 'get',
    params: params
  })
}

export function view(id) {
  return request({
    url: `${url}/${id}`,
    method: 'get',
    params: {}
  })
}

export function create(params) {
  return request({
    url: `${url}`,
    method: 'post',
    params: params
  })
}

export function update(params) {
  return request({
    url: `${url}/${params.id}`,
    method: 'put',
    params: params
  })
}

export function remove(id) {
  return request({
    url: `${url}/${id}`,
    method: 'delete'
  })
}

export function enabled(params) {
  return request({
    url: `${url}/${params.id}/enabled/${params.enabled}`,
    method: 'put'
  })
}

export function sendVerificationCode(params) {
  return request({
    url: `/auth-service/verifycodes/get_verifycode?phone=${params.email}&fromType=verify_email`,
    method: 'get',
  })
}

export function loginByEmail(params) {
  return request({
    url: `/auth-service/auths/login/WRITER_INTERNATIONAL`,
    method: 'post',
    params: params
  })
}